import React from 'react';

type Props = {
  display: boolean,
  message: string,
  type?: string,
  onClose?: () => void,
}

const Alert = (props: Props): React.ReactElement => {
  const {
    message, display, type, onClose,
  } = props;
  let classes = `alert alert-${type || 'primary'} fade show`;
  if (onClose) {
    classes += ' alert-dismissible';
  }
  if (!display) {
    classes += ' d-none';
  }

  return (
    <div className={classes}>
      {message}
      {onClose && (
        <button type="button" className="close" aria-label="Close" onClick={onClose}>
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </div>
  );
};

export default Alert;
